import React from 'react';
import PropTypes from 'prop-types';
import { HeaderContainer, CloseButton } from './style';
export var Header = function Header(props) {
  return React.createElement(HeaderContainer, null, props.content && props.content.title ? React.createElement("h1", null, props.content.title) : null, props.content && React.createElement(CloseButton, {
    onClick: props.handleHide
  }, "x"));
};
Header.propTypes = {
  handleHide: PropTypes.func,
  content: PropTypes.object,
  color: PropTypes.string
};